import { useMemo } from 'react';

import { useAuth } from '@/hooks';

export const useIsBeginnerPlan = () => {
  const auth = useAuth();
  const begginnerPlans = useMemo(() => ['Iniciante', 'Iniciante Antigo'], []);

  return useMemo(() => begginnerPlans.includes(auth.user.company.combo.name), [auth.user.company.combo]);
};
